<!--
* @description:
* @fileName pageConfig.vue
* @author hvv
* @date 2022/01/13 15:21:21
!-->
<template>
  <div>
    <vab-query-form>
      <vab-query-form-left-panel :span="12">
        <el-button :icon="Plus" type="primary" @click="handleEdit($event)">添加</el-button>
        <!-- <el-button :icon="Delete" type="danger" @click="handleDelete($event)">
          批量删除
        </el-button> -->
      </vab-query-form-left-panel>
      <vab-query-form-right-panel :span="12">
        <el-form :inline="true" :model="queryForm" @submit.prevent>
          <el-form-item label="页面名称:">
            <el-input v-model.trim="queryForm.name" clearable placeholder="请输入名称" />
          </el-form-item>
          <!-- <el-form-item label="企业:">
            <el-select v-model="queryForm.enterpriseCode" @change="queryData">
              <template v-for="(item, index) in enterPriseList" :key="index">
                <el-option
                  :value="item.enterpriseCode"
                  :label="item.enterpriseName"
                ></el-option>
              </template>
            </el-select>
          </el-form-item> -->
          <el-form-item>
            <el-button :icon="Search" type="primary" @click="queryData">查询</el-button>
          </el-form-item>
        </el-form>
      </vab-query-form-right-panel>
    </vab-query-form>
    <el-table v-loading="listLoading" border :data="list">
      <el-table-column label="模版ID" prop="id" show-overflow-tooltip />
      <el-table-column label="模版名称" prop="name" show-overflow-tooltip />
      <el-table-column label="模版类型" prop="name" show-overflow-tooltip>
        <template #default="{ row }">
          <el-tag>企业主页</el-tag>
        </template>
      </el-table-column>
      <el-table-column label="状态" prop="status" show-overflow-tooltip>
        <template #default="{ row }">
          <el-switch
            v-model="row.status"
            active-text="上线"
            inactive-text="下线"
            size="large"
            @change="shopStatusChange(row.id, row.status)"
          />
        </template>
      </el-table-column>
      <el-table-column label="操作" show-overflow-tooltip width="285">
        <template #default="{ row }">
          <el-button type="primary" @click="handleEdit(row)">
            <vab-icon icon="edit-2-line" />
            编辑
          </el-button>

          <el-button type="info" @click="handleConfig(row)">
            <vab-icon icon="settings-6-line" />
            配置
          </el-button>

          <el-button type="danger" @click="handleDelete(row)">
            <vab-icon icon="settings-6-line" />
            删除
          </el-button>
        </template>
      </el-table-column>
      <template #empty>
        <!-- <el-image
                class="vab-data-empty"
                :src="require('@/assets/empty_images/data_empty.png')"
              /> -->
        <el-empty class="vab-data-empty" description="暂无数据" />
      </template>
    </el-table>
    <el-pagination
      background
      :current-page="queryForm.pageNumber"
      :layout="layout"
      :page-size="queryForm.pageSize"
      :total="total"
      @current-change="handleCurrentChange"
      @size-change="handleSizeChange"
    />
    <edit ref="editRef" @fetch-data="queryData" />
  </div>
</template>

<script>
  import { defineComponent, defineAsyncComponent, getCurrentInstance, onMounted, reactive, toRefs, computed } from 'vue'
  import { useStore } from 'vuex'

  import { Delete, Plus, Search } from '@element-plus/icons'
  import { getPage, pageStatus, deletePage } from '@/api/page'
  import { getUserEnterPriseAccount } from '@/api/user'
  export default defineComponent({
    name: 'PageConfig',
    components: {
      Edit: defineAsyncComponent(() => import('./components/pageEnterEdit')),
    },
    setup() {
      const { proxy } = getCurrentInstance()

      const store = useStore()
      const state = reactive({
        queryForm: { name: '', pageNumber: 1, pageSize: 10 },
        enterPriseList: [],
        total: 0,
        listLoading: false,
        list: [],
        layout: 'prev, pager, next',
        editRef: null,
        userInfoData: {},
      })

      const handleEdit = (row) => {
        if (row.id) {
          state.editRef.showEdit(row, state.queryForm.enterpriseCode)
        } else {
          state.editRef.showEdit(null, state.queryForm.enterpriseCode)
        }
      }

      const handleConfig = (row) => {
        proxy.$router.replace(`/page/pageConfigModule?id=${row.id}&enterpriseCode=${state.queryForm.enterpriseCode}`)
      }

      const handleDelete = (row) => {
        if (row.id) {
          proxy.$baseConfirm('你确定要删除当前项吗', null, async () => {
            const { msg } = await deletePage(row.id)
            proxy.$baseMessage(`操作成功`, 'success', 'vab-hey-message-success')
            await fetchData()
          })
        }
      }

      const queryData = () => {
        queryFormData()
      }

      const queryFormData = async () => {
        state.listLoading = true
        const { data } = await getPage(state.queryForm)
        state.list = data.list
        state.total = data.total
        state.listLoading = false
      }

      const fetchData = async () => {
        let userInfoData = JSON.parse(localStorage.getItem('userInfo'))
        console.log(userInfoData)
        let params = {
          tid: userInfoData.tid,
          iamUid: userInfoData.uid,
        }
        const { data: userInfo } = await getUserEnterPriseAccount(params)
        state.enterPriseList = userInfo
        // state.queryForm.enterpriseCode = userInfo[0].enterpriseCode
        state.listLoading = true
        const { data } = await getPage(state.queryForm)
        state.list = data.list
        state.total = data.total
        state.listLoading = false
      }

      const handleSizeChange = (val) => {
        state.queryForm.pageSize = val
        fetchData()
      }
      const handleCurrentChange = (val) => {
        state.queryForm.pageNumber = val
        fetchData()
      }

      const shopStatusChange = async (id, status) => {
        let statusKey = status ? 'ACTIVATION' : 'OFFLINE'
        try {
          await pageStatus(id, statusKey)
          proxy.$baseMessage(`操作成功`, 'success', 'vab-hey-message-success')
        } catch (e) {
          console.log(e)
        }

        fetchData()
      }

      onMounted(() => {
        fetchData()
      })
      return {
        ...toRefs(state),
        handleEdit,
        queryData,
        fetchData,
        handleSizeChange,
        handleCurrentChange,
        handleDelete,
        shopStatusChange,
        handleConfig,
        Delete,
        Search,
        Plus,
      }
    },
  })
</script>
<style lang="scss" scoped></style>
